import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/articles/components/ArticlesHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/articles/components/ArticlesList.tsx");
